import React from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {Route } from 'react-router-dom';

import Header from './header';
import Navigation from './navigation';
import ProductDetails from './product_details';
import Cart from './cart';
import Quotation from './quotation';

import Login from '../Login'
import ProductType from '../ProductType'
import ConnectorType from '../ConnectorType'
import FiberType from '../FiberType'
import CableType from '../CableType'
import CableLength from '../CableLength'
import PackagingType from '../PackagingType'
import OptionalAttributes from '../OptionalAttributes'

import axios from 'axios'

import {
    userLogin,
    setPriceTier,
    setAppVersion
} from '../../modules/user'

import {
    setCartItems
} from '../../modules/cart'

require('viewport-units-buggyfill').init();

class App extends React.Component {

    componentWillMount(){
        this.checkPathAllowed();
    }

    componentDidMount(){
        this.getSession();
    }

    checkPathAllowed(){

        if(this.props.routing.location.pathname === "/ConnectorType" && this.props.order.product_type === null){
            window.location.href = "/ProductType";
        }

        if(this.props.routing.location.pathname === "/FiberType" && this.props.order.connector_type === null){
            window.location.href = "/ProductType";
        }

        if(this.props.routing.location.pathname === "/CableType" && this.props.order.fiber_type === null){
            window.location.href = "/ProductType";
        }

        if(this.props.routing.location.pathname === "/CableLength" && this.props.order.cable_type === null){
            window.location.href = "/ProductType";
        }

        if(this.props.routing.location.pathname === "/PackagingType" && this.props.order.cable_length === null){
            window.location.href = "/ProductType";
        }

        if(this.props.routing.location.pathname === "/OptionalAttributes" && this.props.order.packaging_type === null){
            window.location.href = "/ProductType";
        }
    }

    getSession(){

        const _props = this.props;

        axios({
            method: 'get',
            url: this.props.config.api_path+'getUser'
        })
        .then(function (response) {

            if(response.data.user){
                _props.userLogin({
                    user: response.data.user,
                    currency: response.data.user.default_currency
                });

                //GET SESSION PRICE TIER
                axios({
                    method: 'get',
                    url: _props.config.api_path+'getSessionPriceTier'
                })
                .then(function (response) {
                    _props.setPriceTier({
                        price_tier: response.data.price_tier,
                        price_tier_multiplier: response.data.price_tier_multiplier,
                        price_tier_multiplier_dragonfly: response.data.price_tier_multiplier_dragonfly
                    });
                })
                .catch(function (error) {
                    console.log(error)
                });

                //GET SESSION CART
                axios({
                    method: 'get',
                    url: _props.config.api_path+'getSessionCart'
                })
                .then(function (response) {
                    _props.setCartItems({
                        items: response.data.cart
                    });
                })
                .catch(function (error) {
                    console.log(error)
                });

            }

            if(response.data.app_version){
                _props.setAppVersion({
                    app_version: response.data.app_version
                })
            }

        })
        .catch(function (error) {
            console.log(error)
        })
    }

    render() {

        return(
            <div>
                {this.props.routing.location.pathname !== "/" &&
                    <Header/>
                }
                {this.props.routing.location.pathname !== "/" &&
                    <Navigation/>
                }
                {this.props.routing.location.pathname !== "/" &&
                    <ProductDetails/>
                }
                {this.props.routing.location.pathname !== "/" &&
                    <Cart/>
                }
                {this.props.routing.location.pathname !== "/" &&
                    <Quotation/>
                }
                <Route exact path="/" component={Login}/>
                <Route exact path="/ProductType" component={ProductType}/>
                <Route exact path="/ConnectorType" component={ConnectorType}/>
                <Route exact path="/FiberType" component={FiberType}/>
                <Route exact path="/CableType" component={CableType}/>
                <Route exact path="/CableLength" component={CableLength}/>
                <Route exact path="/PackagingType" component={PackagingType}/>
                <Route exact path="/OptionalAttributes" component={OptionalAttributes}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    routing: state.routing,
    order: state.order
})

const mapDispatchToProps = dispatch => bindActionCreators({
    userLogin,
    setPriceTier,
    setCartItems,
    setAppVersion
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/app/index.js